import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GlobalNav from '../../globalComponents/GlobalNav';
import Footer from '../../globalComponents/Footer';


const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [cooldown, setCooldown] = useState(0); // seconds the submit button stays disabled
  const navigate = useNavigate();

  const COOLDOWN_KEY = 'pce_iam_forgot_cooldown_until';
  const COOLDOWN_SECONDS = 30;

  // Restore any cooldown still running from a previous submit, so it holds
  // even after navigating away and coming back (or reloading the page).
  useEffect(() => {
    const until = parseInt(localStorage.getItem(COOLDOWN_KEY) || '0', 10);
    const remaining = Math.ceil((until - Date.now()) / 1000);
    if (remaining > 0) setCooldown(remaining);
  }, []);

  // Count the cooldown down to 0, re-enabling the button
  useEffect(() => {
    if (cooldown <= 0) return;
    const timer = setInterval(() => {
      setCooldown((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [cooldown]);

  // Disable the button for `seconds` and persist the expiry so it survives
  // navigation / reload.
  const startCooldown = (seconds) => {
    localStorage.setItem(COOLDOWN_KEY, String(Date.now() + seconds * 1000));
    setCooldown(seconds);
  };

  // Display helper: mm:ss for >= 60s, otherwise "30s"
  const fmtTime = (s) =>
    s >= 60 ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}` : `${s}s`;

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Hard guard using the persisted timestamp so the cooldown holds across
    // navigation/remount (component state alone resets on a fresh mount).
    const until = parseInt(localStorage.getItem(COOLDOWN_KEY) || '0', 10);
    if (until > Date.now()) {
      setCooldown(Math.ceil((until - Date.now()) / 1000));
      return;
    }

    setMessage('');

    // Start the normal per-click cooldown (timer counts down on the button).
    startCooldown(COOLDOWN_SECONDS);

    try {
      const response = await fetch('/pceapi/auth/iamuser/forgot', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email}),
      });

      // Rate limited (too many requests): lock the button for the remaining
      // time the server reports via Retry-After.
      if (response.status === 429) {
        const retryAfter = parseInt(response.headers.get('Retry-After') || '0', 10);
        if (retryAfter > 0) startCooldown(retryAfter);
      }

      const data = await response.json();

      if (data.status === 'success') {
        navigate('/reset-password', { state: { email } });
      } else {
        setMessage(data.message || 'An error occurred');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
    }
  };

  return (
    <div className="main-window">
    <div className="container">
      <div className="auth-nav-bottom-margin">
        <GlobalNav/>
      </div>
        <div className="col-xl-5 col-lg-6 col-md-7 col-sm-10 mx-auto">
        <div className="text-center">
            <p className="ev-med-p-dark mb-2">Forgot Password</p>
            <p className="ev-message-card2 mb-4 rounded p-2 ">Enter your email address below, and we'll send you a verification code. You'll need to enter this code in the next steps to reset your password.</p>
          </div>
        
        <form  onSubmit={handleSubmit}>
          <label className="ev-reg-p-dark mb-1 mt-3">Email <span className="text-danger">*</span></label>
              <input
                id="email-address" name="email" type="email" autoComplete="email" className="formField3" placeholder="E.g. john@pharmacoevidence.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <br/>
              <div className="text-end">
                <button type="submit" disabled={cooldown > 0} className="ev-btn-blue-fill-round ev-btn-med ev-bold-reg mt-3" style={{opacity: cooldown > 0 ? 0.6 : 1, cursor: cooldown > 0 ? 'not-allowed' : 'pointer'}}>
                  {cooldown > 0 ? `Please wait ${fmtTime(cooldown)}` : <>Send verification code <i className="bi bi-chevron-right"></i></>}
                </button>
              </div>
        </form>
        
        {message && (
           <div className="mt-3 alert alert-danger">{message}</div>

        )}
        </div>
    </div>
    <Footer/>
    </div>
  );
};

export default ForgotPassword;